<template>
  <div v-show="visible" class="toast">
    <!-- <div class="weui-mask_transparent"></div> -->
    <div class="weui-toast">
      <p class="weui-toast__content">{{content}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      visible: false,
      content: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  line-height: 1.6;
  font-family: -apple-system-font, 'Helvetica Neue', sans-serif;
}
.weui-toast {
  position: fixed;
  z-index: 1010;
  padding: 8px;
  line-height: 1.4;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(17, 17, 17, 0.8);
  text-align: center;
  border-radius: 5px;
  color: #ffffff;
}
.weui-toast__content {
  font-size: 14px;
}
.weui-mask_transparent {
  position: fixed;
  z-index: 1011;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/cs180824/common/toast.vue